export default __webpack_public_path__ + "static/media/privacyImg.4825e82b.jpg";